import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { package as PackagePropType } from 'lib/CustomPropTypes';
import LeadBorderTop from 'components/LeadBorderTop';
import TeaseCard from 'components/TeaseCard';
import TeasePicture from 'components/TeasePicture';
import AIMS_FLAVORS from 'lib/aimsFlavors';

const teaseStyles = require('./teaseStyles.module.scss');

function getPicture(item, index) {
  let responsiveFlavors = {
    s: AIMS_FLAVORS.FOCAL_760x380,
    m: AIMS_FLAVORS.FOCAL_460x460,
    l: AIMS_FLAVORS.FOCAL_240x240,
    xl: AIMS_FLAVORS.FOCAL_300x300,
  };
  if (index === 0) {
    responsiveFlavors = {
      ...responsiveFlavors,
      m: AIMS_FLAVORS.FOCAL_920x460,
      l: AIMS_FLAVORS.FOCAL_440x440,
      xl: AIMS_FLAVORS.FOCAL_560x560,
    };
  }
  return (
    <TeasePicture
      responsiveFlavors={responsiveFlavors}
      type={item.type}
      computedValues={item.computedValues}
    />
  );
}

function getTease(item, index, packageMetadata) {
  return (
    <TeaseCard
      key={item.id}
      content={item}
      styles={teaseStyles}
      {...packageMetadata}
      {...item.metadata}
    >
      {getPicture(item, index)}
    </TeaseCard>
  );
}

function Mosaic({
  content,
  pkgClassName,
  includeGrid,
}) {
  if (!content || !(content.items && content.items[0] && content.items[0].item)) return null;
  const {
    id, items, metadata = {}, packageIndex,
  } = content;
  const containerClasses = classNames(
    pkgClassName,
    'mosaic',
    `pkg-index-${packageIndex + 1}`,
    { 'layout-grid-container': includeGrid },
  );

  return (
    <section data-packageid={id} className={containerClasses} data-test="mosaic__section">
      <LeadBorderTop types={['collectionLead']} customStyles="mosaic__border-top" />
      <div className={classNames('mosaic__content', { 'layout-grid-item': includeGrid })}>
        { items.filter((item) => item).map((item, index) => getTease(item, index, metadata)) }
      </div>
    </section>
  );
}

Mosaic.propTypes = {
  content: PackagePropType.isRequired,
  pkgClassName: PropTypes.string,
  includeGrid: PropTypes.bool,
};

Mosaic.defaultProps = {
  pkgClassName: 'pkg mosaic',
  includeGrid: false,
};

export default Mosaic;
